import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { rolDisable } from "../../store/rol/actions";
export var useRolDisable = function (trigger, body) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseRolDisable: state.Rol.responseRolDisable,
        errorRolDisable: state.Rol.errorRolDisable,
        loadingRolDisable: state.Rol.loadingRolDisable,
    }); }), responseRolDisable = _a.responseRolDisable, errorRolDisable = _a.errorRolDisable, loadingRolDisable = _a.loadingRolDisable;
    useEffect(function () {
        if (trigger) {
            dispatch(rolDisable(body.id));
        }
    }, [trigger]);
    return {
        responseRolDisable: responseRolDisable,
        errorRolDisable: errorRolDisable,
        loadingRolDisable: loadingRolDisable,
    };
};
